import { render, staticRenderFns } from "./FileMappingDetailsPage.vue?vue&type=template&id=8bcdf236&"
import script from "./FileMappingDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./FileMappingDetailsPage.vue?vue&type=script&lang=ts&"
import style0 from "./FileMappingDetailsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports